// Module
var code = "<checkbox-field v-if=\"form\" :label=\"name\" v-model=\"form[field]\" :validation=\"form.validation[field]\" :disabled=\"disabled\"> <slot>{{ name }}</slot> </checkbox-field> ";
// Exports
export default code;